"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _whatsNew = require('shared/services/whatsNew');

// Web and desktop remember the pill per user in this browser profile.
// Reading localStorage itself can throw (blocked site data); the shared
// store then shows the pill.
 const whatsNew = _whatsNew.createWhatsNew.call(void 0, {
  getItem: key => window.localStorage.getItem(key),
  setItem: (key, value) => window.localStorage.setItem(key, value),
}, {
  onFocus: refresh => window.addEventListener('focus', refresh),
}); exports.whatsNew = whatsNew
